import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {MenuItem} from 'patient-ping-remedy/packages/menu';

export const Wrapper = styled.div`
  flex: 1;
  max-width: 30rem;
  min-width: 18rem;

  & > span {
    width: 100%;
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${sizes.xSmall};
  padding: 0 ${sizes.xSmall};
  height: ${sizes.large};
  width: 100%;
  font-family: inherit;
  font-size: ${fontSize.small};
  background: ${colors.white};
  border: 1px solid ${colors.gray2};
  border-radius: 8px;
  cursor: pointer;
`;

export const SavedLabel = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const PlaceholderLabel = styled.div`
  color: ${colors.gray4};
`;

export const PlaceholderIcon = styled.div`
  margin-right: -0.2rem;
  font-size: ${fontSize.standard};
  color: ${colors.purple4};
`;

export const HoverMenuItem = styled(MenuItem)`
  & > div {
    visibility: hidden;
  }

  &:hover > div {
    visibility: visible;
  }
`;

export const Action = styled.div`
  margin-right: -0.4rem;
  padding: 0.4rem;
  cursor: pointer;
  color: ${colors.purple4};

  &:hover {
    color: ${colors.purple5};
  }
`;
